import {grid} from '@xh/hoist/cmp/grid';
import {hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {dialog} from '@xh/hoist/kit/blueprint';
import {CashFlowsDialogModel} from './CashFlowsDialogModel';

export const cashFlowsDialog = hoistCmp.factory<CashFlowsDialogModel>(({model}) =>
    dialog({
        style: {width: 360, height: 500},
        icon: Icon.dollarSignCircle(),
        title: 'Cash Flows',
        canOutsideClickClose: false,
        isOpen: model.isOpen,
        onClose: () => model.close(),
        item: panel({
            item: grid(),
            mask: model.apiTask
        })
    })
);
